import React from "react";
import { Facebook, Instagram, Youtube, Phone, Mail, MapPin, ArrowUp } from "lucide-react";
import { siteInfo, navLinks } from "../mock/mock";

const Footer = () => {
  const scrollTop = () => window.scrollTo({ top: 0, behavior: "smooth" });

  return (
    <footer className="bg-neutral-950 text-neutral-300 pt-16 pb-6">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-10">
          {/* Brand */}
          <div className="lg:col-span-1">
            <div className="flex items-center gap-3" style={{ fontFamily: "'Poppins', sans-serif" }}>
              <img
                src="/logo.jpeg?v=2"
                alt="RR Bros Bike Rental Udupi and Manipal"
                loading="lazy"
                className="h-14 w-auto rounded-md"
              />
              <div className="leading-none">
                <p className="font-extrabold text-white text-xl">RR Bros</p>
                <p className="text-[11px] font-semibold text-orange-400 tracking-[0.18em] mt-1 uppercase">
                  Bike Rental
                </p>
              </div>
            </div>
            <p className="text-sm text-neutral-400 mt-4 leading-relaxed">
              Affordable, well-maintained scooters for rent in Udupi & Manipal.
              Ride when you need it most.
            </p>
            <div className="flex items-center gap-3 mt-5">
              {[Facebook, Instagram, Youtube].map((Icon, i) => (
                <a
                  key={i}
                  href="#"
                  aria-label="social"
                  className="w-9 h-9 rounded-full bg-neutral-800 hover:bg-orange-500 flex items-center justify-center transition-colors"
                >
                  <Icon className="w-4 h-4" />
                </a>
              ))}
            </div>
          </div>

          {/* Links */}
          <div>
            <h4 className="text-white font-black uppercase tracking-wider text-sm mb-4">
              Quick Links
            </h4>
            <ul className="space-y-2.5 text-sm">
              {navLinks.map((l) => (
                <li key={l.name}>
                  <a href={l.href} className="hover:text-orange-400 transition-colors">
                    {l.name}
                  </a>
                </li>
              ))}
            </ul>
          </div>

          {/* Contact */}
          <div>
            <h4 className="text-white font-black uppercase tracking-wider text-sm mb-4">
              Get In Touch
            </h4>
            <ul className="space-y-3 text-sm">
              <li className="flex items-start gap-2">
                <Phone className="w-4 h-4 text-orange-500 mt-0.5 flex-shrink-0" />
                <a href={`tel:${siteInfo.phone.replace(/\s/g, "")}`} className="hover:text-orange-400 transition-colors">
                  {siteInfo.phoneDisplay}
                </a>
              </li>
              <li className="flex items-start gap-2">
                <Mail className="w-4 h-4 text-orange-500 mt-0.5 flex-shrink-0" />
                <a href={`mailto:${siteInfo.email}`} className="hover:text-orange-400 transition-colors">
                  {siteInfo.email}
                </a>
              </li>
              <li className="flex items-start gap-2">
                <MapPin className="w-4 h-4 text-orange-500 mt-0.5 flex-shrink-0" />
                <span>Udupi &bull; Manipal, Karnataka</span>
              </li>
            </ul>
          </div>

          {/* Timings */}
          <div>
            <h4 className="text-white font-black uppercase tracking-wider text-sm mb-4">
              Working Hours
            </h4>
            <ul className="space-y-2 text-sm">
              <li>
                <span className="text-neutral-500">Udupi</span>
                <br />
                <span className="font-semibold">Mon-Sun: 7:30 AM - 7:30 PM</span>
              </li>
              <li>
                <span className="text-neutral-500">Manipal</span>
                <br />
                <span className="font-semibold">Mon-Sun: 9:00 AM - 7:30 PM</span>
              </li>
            </ul>
          </div>
        </div>

        <div className="mt-12 pt-6 border-t border-neutral-800 flex flex-col sm:flex-row items-center justify-between gap-4">
          <div className="flex flex-col sm:flex-row items-center gap-2 sm:gap-4 text-xs text-neutral-500 text-center sm:text-left">
            <p>
              &copy; {new Date().getFullYear()} RR Bros Bike Rental. All rights reserved.
            </p>
            <span className="hidden sm:inline text-neutral-700">|</span>
            <a href="/terms" className="hover:text-orange-400 transition-colors">
              Terms &amp; Conditions
            </a>
          </div>
          <button
            onClick={scrollTop}
            className="flex items-center gap-2 text-xs font-bold uppercase tracking-wider text-neutral-400 hover:text-orange-400 transition-colors"
          >
            Back to top <ArrowUp className="w-3.5 h-3.5" />
          </button>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
